import { useLanguage } from "@/contexts/LanguageContext";
import type { Language } from "@/i18n/translations";
import { Languages } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const LANGUAGES = [
  { value: "en", label: "EN" },
  { value: "fa", label: "FA" },
] as const;

export const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <Select
      value={language}
      onValueChange={(val) => setLanguage(val as Language)}
    >
      <SelectTrigger className="w-[52px] h-11 text-xs gap-1 bg-card px-1.5 justify-center">
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-popover z-50">
        {LANGUAGES.map((lang) => (
          <SelectItem key={lang.value} value={lang.value} className="text-sm">
            {lang.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
